export type SolutionVendorFields = {
  documentId: string
  publishedAt?: any | null
  users: Array<{ external_id?: string | null } | null>
} | null

type SolutionWithVendor = {
  vendor?: {
    documentId?: string | null
    publishedAt?: any | null
    users?: Array<{ external_id?: string | null } | null> | null
  } | null
}

export type FetchPublishedVendor = (
  documentId: string,
  requestHeaders?: any,
) => Promise<SolutionVendorFields>

/**
 * Replaces nested draft vendor data with the published vendor for the same documentId.
 * If the vendor has no published version, sets vendor to null.
 */
export async function attachPublishedVendor<T extends SolutionWithVendor>(
  solution: T,
  fetchPublishedVendor: FetchPublishedVendor,
  requestHeaders?: any,
): Promise<T> {
  const documentId = solution.vendor?.documentId
  if (!documentId) {
    return { ...solution, vendor: null }
  }

  const publishedVendor = await fetchPublishedVendor(documentId, requestHeaders)
  return { ...solution, vendor: publishedVendor }
}
